import * as React from 'react';
import { styled, useTheme, createTheme } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import FormatIndentDecreaseIcon from '@mui/icons-material/FormatIndentDecrease';
// import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DashboardIcon from '@mui/icons-material/Dashboard';
// import CastConnectedIcon from '@mui/icons-material/CastConnected';
import '../common-navbar/navbar.css';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ExpandLess from '@mui/icons-material/ExpandLess';
import Tooltip from '@mui/material/Tooltip';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Collapse from '@mui/material/Collapse';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useNavigate } from 'react-router-dom';
import Logo from '../../../assets/loginlogo.png';
import AdminLogo from '../../../assets/loginlogoicon.png';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import LanguageIcon from '@mui/icons-material/Language';
import { useSelector } from 'react-redux';
import ListAltIcon from '@mui/icons-material/ListAlt';
const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  position: 'sticky',
  top: 0,
  zIndex: 10,
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',


    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
      background: 'black',
      color: 'white',
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
      background: 'black',
      color: 'white',
    }),
  }),
);

export default function Navbar(props) {
  const { accessRights } = useSelector(store => store.login)
  const navigate = useNavigate()
  let selInd = sessionStorage.getItem("selectedIndex") == null ? 1 : sessionStorage.getItem("selectedIndex")
  let childInd = sessionStorage.getItem("selectedChilIndex") == null ? 0 : sessionStorage.getItem("selectedChilIndex")

  const [selectedIndex, setSelectedIndex] = React.useState(parseInt(selInd));
  const [childIndexSetup, setChildIndexSetup] = React.useState(parseInt(childInd))
  const [openSetupToggle, setOpenSetupToggle] = React.useState(false);
  const [adminToggle, setAdminToggle] = React.useState(false)
  const [systemToggle, setSystemToggle] = React.useState(false)
  // const theme = useTheme();
  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1450,
      },
    },
  });

  const xlResolutionIdentifier = useMediaQuery(theme.breakpoints.down('xl'));
  const lgResolutionIdentifier = useMediaQuery(theme.breakpoints.down('lg'));
  const mdResolutionIdentifier = useMediaQuery(theme.breakpoints.down('md'));
  const smResolutionIdentifier = useMediaQuery(theme.breakpoints.down('sm'));
  const xsResolutionIdentifier = useMediaQuery(theme.breakpoints.down('xs'));
  const [largeRes, setLargeRes] = React.useState(false)
  const [smallRes, setSmallRes] = React.useState(false)
  React.useEffect(() => {
    if (xlResolutionIdentifier || lgResolutionIdentifier) {
      setLargeRes(true)
      setSmallRes(false)
    }
    else {
      setLargeRes(false)
      setSmallRes(true)
    }
  }, [xlResolutionIdentifier, lgResolutionIdentifier, mdResolutionIdentifier, smResolutionIdentifier, xsResolutionIdentifier])

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    props.drawerClose()
  };



  return (
    <>


      {largeRes && <SwipeableDrawer
        className='small-drawer'
        anchor={'left'}
        open={props.open}
        onClose={toggleDrawer('left', false)}
        onOpen={toggleDrawer('left', true)}
      >

        <DrawerHeader style={{ backgroundColor: "#1976d2" }}>
          <img src={Logo} style={{ position: 'absolute', left: '7px', width: '155px' }} />
          <IconButton onClick={props.drawerClose} sx={{ display: 'flex', justifyContent: 'space-between' }}>
            {theme.direction === 'rtl' ? <ChevronRightIcon /> : <FormatIndentDecreaseIcon sx={{ color: '#fff', size: 20 }} />}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          <ListItem disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              id="nav-1"
              selected={selectedIndex === 1}
              onClick={() => {
                sessionStorage.setItem('selectedIndex', 1)
                props.navigateOne()
                setSelectedIndex(1)
                setChildIndexSetup(0)
                setOpenSetupToggle(false);
                setAdminToggle(false)
                setSystemToggle(false)
                props.drawerClose()
              }
              }
              sx={{
                minHeight: 48,
                justifyContent: props.open ? 'initial' : 'center',
                px: 2.5,

              }
              }
            >
              <Tooltip title={window.gt('Dashboard')} placement="right" arrow><ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: props.open ? 3 : 'auto',
                  justifyContent: 'center',
                }}
              >
                <DashboardIcon className={props.open ? 'no-apply-btn' : 'apply-btn'} />
              </ListItemIcon></Tooltip>
              <ListItemText primary={window.gt('Dashboard')} sx={{ opacity: props.open ? 1 : 0 }} />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              id="nav-2"
              selected={selectedIndex === 2}
              onClick={() => {
                sessionStorage.setItem('selectedIndex', 2)
                setSelectedIndex(2)
                props.setupStructureTrigger()
                setOpenSetupToggle(!openSetupToggle)
                setAdminToggle(false)
                setSystemToggle(false)
              }}

              sx={{
                minHeight: 48,
                justifyContent: props.open ? 'initial' : 'center',
                px: 2.5,

              }
              }
            >
              <Tooltip title={window.gt('Administration')} placement="right" arrow><ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: props.open ? 3 : 'auto',
                  justifyContent: 'center',
                }}
              >
                <ManageAccountsIcon className={props.open ? 'no-apply-btn' : 'apply-btn'} />
              </ListItemIcon></Tooltip>
              <ListItemText primary={window.gt('Administration')} sx={{ opacity: props.open ? 1 : 0 }} />
              {props.open && <span>{openSetupToggle ? <ExpandLess /> : <ExpandMore />}</span>}
            </ListItemButton>
            {props.open && <Collapse in={openSetupToggle} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton sx={{ pl: 8.7 }} id="nav-a-1" className='child-selected' onClick={() => {
                  setChildIndexSetup(1)
                  sessionStorage.setItem('selectedIndex', 2)
                  sessionStorage.setItem('selectedChilIndex', 1)
                  setSelectedIndex(2)
                  props.setupStructureTrigger()
                  props.triggerUserAccountsStructure()
                  props.drawerClose()
                }} selected={childIndexSetup === 1}>
                  <ListItemText primary={window.gt('User Accounts')} />
                </ListItemButton>
                <ListItemButton sx={{ pl: 8.7 }} id="nav-a-2" className='child-selected' onClick={() => {
                  setChildIndexSetup(2)
                  sessionStorage.setItem('selectedIndex', 2)
                  sessionStorage.setItem('selectedChilIndex', 2)
                  setSelectedIndex(2)
                  props.navigateReport()
                  props.drawerClose()
                }} selected={childIndexSetup === 2}>
                  <ListItemText primary={window.gt('Reports')} />
                </ListItemButton>
                <ListItemButton sx={{ pl: 8.7 }} id="nav-a-3" className='child-selected' onClick={() => {
                  setChildIndexSetup(3)
                  sessionStorage.setItem('selectedIndex', 2)
                  sessionStorage.setItem('selectedChilIndex', 3)
                  setSelectedIndex(2)
                  setOpenSetupToggle(true)
                  props.navigatePreference()
                }} selected={childIndexSetup === 3}>
                  <ListItemText primary={window.gt('Preference')} />
                </ListItemButton>
              </List>
            </Collapse>}
          </ListItem>

          <ListItem disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              id="nav-3"
              selected={selectedIndex === 3}
              onClick={() => {
                sessionStorage.setItem('selectedIndex', 3)
                setSelectedIndex(3)
                setOpenSetupToggle(false)
                props.setupStructureTrigger()
                if (systemToggle) {
                  setSystemToggle(false)
                }
                else {
                  setSystemToggle(true)
                }
              }}

              sx={{
                minHeight: 48,
                justifyContent: props.open ? 'initial' : 'center',
                px: 2.5,

              }
              }
            >
              <Tooltip title={window.gt('Systems')} placement="right" arrow><ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: props.open ? 3 : 'auto',
                  justifyContent: 'center',
                }}
              >
                <LanguageIcon className={props.open ? 'no-apply-btn' : 'apply-btn'} />
              </ListItemIcon></Tooltip>
              <ListItemText primary={window.gt('Systems')} sx={{ opacity: props.open ? 1 : 0 }} />
              {props.open && <span>{systemToggle ? <ExpandLess /> : <ExpandMore />}</span>}
            </ListItemButton>
            {props.open && <Collapse in={systemToggle} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton sx={{ pl: 8.7 }} id="nav-s-1" className='child-selected' onClick={() => {
                  setChildIndexSetup(4)
                  sessionStorage.setItem('selectedIndex', 3)
                  setSelectedIndex(3)
                  props.navigateSystemDatabaseSetup()
                }} selected={childIndexSetup === 4}>
                  <ListItemText primary={window.gt('Database Setup')} />
                </ListItemButton>
                <ListItemButton sx={{ pl: 8.7 }} id="nav-s-2" className='child-selected' onClick={() => {
                  setChildIndexSetup(5)
                  sessionStorage.setItem('selectedIndex', 3)
                  setSelectedIndex(3)
                  props.navigateTemplates()
                }} selected={childIndexSetup === 5}>
                  <ListItemText primary={window.gt('Templates')} />
                </ListItemButton>
                <ListItemButton sx={{ pl: 8.7 }} id="nav-s-2" className='child-selected' onClick={() => {
                  setChildIndexSetup(6)
                  sessionStorage.setItem('selectedIndex', 3)
                  setSelectedIndex(3)
                  props.navigateWorkflow()
                }} selected={childIndexSetup === 6}>
                  <ListItemText primary={window.gt('Workflow')} />
                </ListItemButton>
              </List>
            </Collapse>}
          </ListItem>
        </List>
      </SwipeableDrawer>}

      {smallRes && <Drawer variant="permanent" open={props.open} className="sidebar_bg">
        <DrawerHeader style={{ backgroundColor: "#1976d2" }}>
          <img src={props.open ? Logo : AdminLogo} style={{ position: 'absolute', left: '7px', width: props.open ? '155px' : '50px' }} />
          {props.open && <IconButton onClick={props.drawerClose}>
            {theme.direction === 'rtl' ? <ChevronRightIcon /> : <FormatIndentDecreaseIcon sx={{ color: '#fff' }} />}
          </IconButton>}
        </DrawerHeader>
        <Divider />
        <List>
          <ListItem disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              id="nav-1"
              selected={selectedIndex === 1}
              onClick={() => {
                sessionStorage.setItem('selectedIndex', 1)
                props.navigateOne()
                setSelectedIndex(1)
                setChildIndexSetup(0)
                setOpenSetupToggle(false);
                setAdminToggle(false)
                setSystemToggle(false)
                props.drawerClose()
              }
              }
              sx={{
                minHeight: 48,
                justifyContent: props.open ? 'initial' : 'center',
                px: 2.5,

              }
              }
            >
              <Tooltip title={window.gt('Dashboard')} placement="right" arrow><ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: props.open ? 3 : 'auto',
                  justifyContent: 'center',
                }}
              >
                <DashboardIcon className={props.open ? 'no-apply-btn' : 'apply-btn'} />
              </ListItemIcon></Tooltip>
              <ListItemText primary={window.gt('Dashboard')} sx={{ opacity: props.open ? 1 : 0 }} />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              id="nav-2"
              selected={selectedIndex === 2}
              onClick={() => {
                sessionStorage.setItem('selectedIndex', 2)
                setSelectedIndex(2)
                props.setupStructureTrigger()
                setOpenSetupToggle(!openSetupToggle)
                setAdminToggle(false)
                setSystemToggle(false)
              }}

              sx={{
                minHeight: 48,
                justifyContent: props.open ? 'initial' : 'center',
                px: 2.5,

              }
              }
            >
              <Tooltip title={window.gt('Administration')} placement="right" arrow><ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: props.open ? 3 : 'auto',
                  justifyContent: 'center',
                }}
              >
                <ManageAccountsIcon className={props.open ? 'no-apply-btn' : 'apply-btn'} />
              </ListItemIcon></Tooltip>
              <ListItemText primary={window.gt('Administration')} sx={{ opacity: props.open ? 1 : 0 }} />
              {props.open && <span style={{ position: 'relative', top: '4px' }}>{openSetupToggle ? <ExpandLess /> : <ExpandMore />}</span>}
            </ListItemButton>
            {props.open && <Collapse in={openSetupToggle} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton sx={{ pl: 8.7 }} id="nav-a-1" className='child-selected' onClick={() => {
                  setChildIndexSetup(1)
                  sessionStorage.setItem('selectedIndex', 2)
                  sessionStorage.setItem('selectedChilIndex', 1)
                  setSelectedIndex(2)
                  setOpenSetupToggle(true)
                  props.setupStructureTrigger()
                  props.triggerUserAccountsStructure()
                }} selected={childIndexSetup === 1}>
                  <ListItemText primary={window.gt('User Accounts')} />
                </ListItemButton>
                <ListItemButton 
              sx={{ pl: 8.7 }} id="nav-a-2" className='child-selected'
              selected={selectedIndex === 5}
              onClick={() => {
                sessionStorage.setItem('selectedIndex', 5)
                setSelectedIndex(5)
                props.navigateReport()
                setOpenSetupToggle(false);
                setAdminToggle(false)
                setSystemToggle(false)
                setChildIndexSetup(0)
                props.drawerClose()
              }}
           
            >
            
              <ListItemText primary={window.gt('Reports')} sx={{ opacity: props.open ? 1 : 0 }} />
            </ListItemButton>
                {/* <ListItemButton sx={{ pl: 8.7 }} id="nav-a-2" className='child-selected' onClick={() => {
                  setChildIndexSetup(2)
                  sessionStorage.setItem('selectedIndex', 2)
                  sessionStorage.setItem('selectedChilIndex', 2)
                  setSelectedIndex(2)
                  setOpenSetupToggle(true)
                  props.setupClientTrigger()
                }} selected={childIndexSetup === 2}>
                  <ListItemText primary={window.gt('Reports')} />
                </ListItemButton> */}
                <ListItemButton sx={{ pl: 8.7 }} id="nav-a-3" className='child-selected' onClick={() => {
                  setChildIndexSetup(3)
                  sessionStorage.setItem('selectedIndex', 2)
                  sessionStorage.setItem('selectedChilIndex', 3)
                  setSelectedIndex(2)
                  setOpenSetupToggle(true)
                  props.navigatePreference()
                }} selected={childIndexSetup === 3}>
                  <ListItemText primary={window.gt('Preference')} />
                </ListItemButton>
              </List>
            </Collapse>}
          </ListItem>
          <ListItem disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              id="nav-3"
              selected={selectedIndex === 3}
              onClick={() => {
                sessionStorage.setItem('selectedIndex', 3)
                setSelectedIndex(3)
                setSystemToggle(!systemToggle)
                props.setupStructureTrigger()
                setAdminToggle(false)
                setOpenSetupToggle(false)
              }}

              sx={{
                minHeight: 48,
                justifyContent: props.open ? 'initial' : 'center',
                px: 2.5,

              }
              }
            >
              <Tooltip title={window.gt('Systems')} placement="right" arrow><ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: props.open ? 3 : 'auto',
                  justifyContent: 'center',
                }}
              >
                <LanguageIcon className={props.open ? 'no-apply-btn' : 'apply-btn'} />
              </ListItemIcon></Tooltip>
              <ListItemText primary={window.gt('Systems')} sx={{ opacity: props.open ? 1 : 0 }} />
              {props.open && <span style={{ position: 'relative', top: '2px' }}>{systemToggle ? <ExpandLess /> : <ExpandMore />}</span>}
            </ListItemButton>
            {props.open && <Collapse in={systemToggle} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton sx={{ pl: 8.7 }} id="nav-s-1" className='child-selected' onClick={() => {
                  setChildIndexSetup(4)
                  sessionStorage.setItem('selectedIndex', 3)
                  setSelectedIndex(3)
                  setSystemToggle(true)
                  props.setupStructureTrigger()
                  props.navigateSystemDatabaseSetup()
                }} selected={childIndexSetup === 4}>
                  <ListItemText primary={window.gt('Database Setup')} />
                </ListItemButton>
                <ListItemButton sx={{ pl: 8.7 }} id="nav-s-2" className='child-selected' onClick={() => {
                  setChildIndexSetup(5)
                  sessionStorage.setItem('selectedIndex', 3)
                  setSelectedIndex(3)
                  setSystemToggle(true)
                  props.setupStructureTrigger()
                  props.navigateTemplates()
                }} selected={childIndexSetup === 5}>
                  <ListItemText primary={window.gt('Templates')} />
                </ListItemButton>
                <ListItemButton sx={{ pl: 8.7 }} id="nav-s-2" className='child-selected' onClick={() => {
                  setChildIndexSetup(6)
                  sessionStorage.setItem('selectedIndex', 3)
                  setSelectedIndex(3)
                  setSystemToggle(true)
                  props.setupStructureTrigger()
                  props.navigateWorkflow()
                }} selected={childIndexSetup === 6}>
                  <ListItemText primary={window.gt('Workflow')} />
                </ListItemButton>
              </List>
            </Collapse>}
          </ListItem>
        </List>
      </Drawer>}
    </>
  );
}
